var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-tabs',{model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab',{attrs:{"href":"#tab-nrb"}},[_vm._v(" "+_vm._s(_vm.$t('modules_name.income_generation')))]),_c('v-tab-item',{attrs:{"value":"tab-nrb"}},[(_vm.tab==='tab-nrb')?_c('NrbReportTable'):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }